import { render, staticRenderFns } from "./profiledropdown.vue?vue&type=template&id=61fb65a7&"
import script from "./profiledropdown.vue?vue&type=script&lang=js&"
export * from "./profiledropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fb65a7')) {
      api.createRecord('61fb65a7', component.options)
    } else {
      api.reload('61fb65a7', component.options)
    }
    module.hot.accept("./profiledropdown.vue?vue&type=template&id=61fb65a7&", function () {
      api.rerender('61fb65a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/profiledropdown.vue"
export default component.exports